import UserAssignment_Collection from "../../model/collection";


export default class FormsCallbackManager {

    public callbacks    : callback[]
    public submitData   : UserAssignment_Collection
    public isFormsValid : boolean

    constructor() {
        this.callbacks      = [];
        this.submitData     = new UserAssignment_Collection([]);
        this.isFormsValid   = true
    }

    addCallback(callback: callback) {
        if (typeof callback === "function") {
            this.callbacks.push(callback);
        }
    }

    run() {
        return this.callbacks.map((cb: callback) => cb());
    }

    async runAsync() {
        return Promise.all(this.callbacks.map((cb: callback) => cb()));
    }
}
